module.exports = __webpack_public_path__ + "static/3i-3fe16939288856e8e828fa2661bf2354.woff";